import React from "react";
// export default props => <svg style={props.style} width={props.width} height={props.height} viewBox="0 0 48 48" fill="none" xmlns="https://www.w3.org/2000/svg">
export default (props) => (
  <svg
    style={props.style}
    width={props.width}
    height={props.height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M23 3H47V47H1V3H7"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 27L15 19L7 27V1H23V27Z"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 15H41"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 21H41"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 27H41"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 33H41"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 39H33"
      stroke="#A4A4A4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
